
export const breakImagesPageName = "breakImages";


// WEBPACK FOOTER //
// ./public/pages/EditBreak/utils.js